import { useResources } from '@/api'
import { parsedProp, PropertySchemas } from '@/api/parsing'
import { useAppDispatch, useAppSelector } from '@/app'
import { useCalendarActions, useCalendarSelectors } from '@/features/calendar'
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

type RouteGroupSelectorControllerProps = {
  disabled?: boolean
}

export const RouteGroupSelectorController = ({
  disabled,
}: RouteGroupSelectorControllerProps) => {
  const { t } = useTranslation()
  const actions = useCalendarActions()
  const { selectSelectedGroup } = useCalendarSelectors()
  const selectedGroup = useAppSelector(selectSelectedGroup)
  const dispatch = useAppDispatch()
  const { data: routeGroups } = useResources('RouteGroup')
  const groups = routeGroups?.map(group => ({
    id: group.data.id,
    name: parsedProp(group, PropertySchemas.route.name) ?? '',
    rgroup: parsedProp(group, PropertySchemas.route.resourceGroups) ?? '',
  }))
  return (
    <FormControl fullWidth disabled={disabled} size="small">
      <InputLabel id="select-route-group-label">
        {t('planning.selectroutegroup')}
      </InputLabel>
      <Select
        size="small"
        labelId="select-route-group-label"
        onChange={e => dispatch(actions.selectGroup(e.target.value))}
        value={selectedGroup}
        input={<OutlinedInput label={t('planning.selectroutegroup')} />}
      >
        {groups?.map(it => (
          <MenuItem key={it.id} value={it.id}>
            {it.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
